/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const JSG = require('../../JSG');
const MessageContainer = require('./MessageContainer');
const CaptionNode = require('./CaptionNode');
const ButtonNode = require('./ButtonNode');
const FormatAttributes = require('../attr/FormatAttributes');
const NotificationCenter = require('../notifications/NotificationCenter');
const Notification = require('../notifications/Notification');

module.exports = class OutboxContainer extends MessageContainer {
	constructor() {
		super();

		// outbox caption
		this._outboxCaption = new CaptionNode();
		this._outboxCaption.setName('Outbox');
		this._outboxCaption.setType('oc');
		this.setType('outboxcontainer');
		this.addItem(this._outboxCaption);

		const closeButton = new ButtonNode();
		closeButton.getFormat().setFillStyle(FormatAttributes.FillStyle.PATTERN);
		closeButton.getFormat().setPattern('close');
		closeButton.onClick = this.onClick;
		closeButton.setEventScope(this);
		closeButton.setSize(700, 500);
		closeButton.setTooltip(JSG.getLocalizedString('Hide'));
		this._outboxCaption.addItem(closeButton);
		closeButton.setName('closeOutbox');
		this._closeButton = closeButton;

		this._topMargin = 500;

		this.createItems();
	}

	newInstance() {
		return new OutboxContainer();
	}

	onClick(button) {
		NotificationCenter.getInstance().send(
			new Notification(ButtonNode.BUTTON_CLICKED_NOTIFICATION, { button, container: this })
		);
	}

	get machineContainer() {
		return this.getParent();
	}

	onTreeSelectionChanged(notification) {
		const item = notification.object;

		if (item.getId() === this.getMessageListItems().getId()) {
			const selection = item.getSelection(String(item.getSelectionId()));

			if (selection === undefined) {
				const messageTree = this.getMessageTreeItems();
				messageTree.setJson('{}');
			} else {
				const selId = selection.getValue();
				const selectedItem = item.getTreeItemById(selId);

				if (selectedItem !== undefined) {
					const messageTree = this.getMessageTreeItems();
					let collapsed = messageTree.getCollapsedItemPaths();
					if (collapsed.length === 0) {
						collapsed = messageTree._lastCollapsedState;
					}

					if (selectedItem._json) {
						messageTree.setJson(selectedItem._json);
						messageTree.collapseItemsByPaths(collapsed);
					} else if (selectedItem._userItems) {
						messageTree.jsonTree = selectedItem._userItems;
						messageTree.updateLevels();
					} else {
						messageTree.setJson('{}');
					}
				}
			}
		}
	}

	_assignName(id) {
		this.setName(`OutboxContainer${id}`);
	}

	getItemType() {
		return 'outboxcontainer';
	}

	layout() {
		const box = JSG.boxCache.get();
		const size = this.getSize().toPoint();

		box.setTop(0);
		box.setLeft(0);
		box.setHeight(this._topMargin);
		box.setWidth(size.x);

		this._outboxCaption.setBoundingBoxTo(box);

		box.setTop(0);
		box.setLeft(size.x - 650);
		box.setHeight(500);
		box.setWidth(700);

		this._closeButton.setBoundingBoxTo(box);

		JSG.boxCache.release(box);

		super.layout();
	}
};
